import React from "react";

import DiscountScale from "components/Tvendo/Article/DataMaster/DiscountScale/List.js";

export default function () {
  return <DiscountScale />;
}
